import type { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  currencyISO?: string;
};

export const HeaderCell = ({ label, currencyISO }: Props) => {
  if (typeof currencyISO === 'undefined') {
    return (
      <div className="grid grid-rows-[auto] text-tiny leading-tight text-soft">
        <span className="whitespace-nowrap">{label}</span>
      </div>
    );
  }
  return (
    <div className="grid grid-rows-[auto,auto] text-tiny leading-tight text-soft">
      <span className="font-normal text-softer">{currencyISO}</span>
      <span className="whitespace-nowrap">{label}</span>
    </div>
  );
};
